export function truncateAndMask(input, visibleCount = 5, maskChar = "*") {
  if (!input || visibleCount >= input.length) {
    return input;
  }

  const visiblePart = input.slice(0, visibleCount);
  const maskedPart = maskChar.repeat(input.length - visibleCount);

  return visiblePart + maskedPart;
}
